var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3071 12.7896C38.2595 15.5365 40.9867 19.9038 41.54 24.9431",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68799 25.0422C8.2018 20.0227 10.8894 15.6553 14.8023 12.8887",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9761 41.978C19.2685 43.144 21.877 43.7961 24.6239 43.7961C27.272 43.7961 29.762 43.2033 31.9951 42.1164",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6239 15.8138C27.6581 15.8138 30.1177 13.3541 30.1177 10.32C30.1177 7.28583 27.6581 4.82617 24.6239 4.82617C21.5898 4.82617 19.1301 7.28583 19.1301 10.32C19.1301 13.3541 21.5898 15.8138 24.6239 15.8138Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3361 39.9622C13.3702 39.9622 15.8299 37.5026 15.8299 34.4684C15.8299 31.4343 13.3702 28.9746 10.3361 28.9746C7.30195 28.9746 4.84229 31.4343 4.84229 34.4684C4.84229 37.5026 7.30195 39.9622 10.3361 39.9622Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6745 39.9622C41.7086 39.9622 44.1683 37.5026 44.1683 34.4684C44.1683 31.4343 41.7086 28.9746 38.6745 28.9746C35.6403 28.9746 33.1807 31.4343 33.1807 34.4684C33.1807 37.5026 35.6403 39.9622 38.6745 39.9622Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.69a5085d7237209bcc8ba58f6fe29a24.svg";
export { ForwardRef as ReactComponent };